module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-btn"
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'wait' || _vm.upState == 'loaded'),
      expression: "upState == 'wait' || upState == 'loaded'"
    }],
    ref: "upload",
    staticClass: "upload-btn",
    attrs: {
      "aciton": _vm.loadUrl,
      "before-upload": _vm.prevCtrls,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "show-file-list": false,
      "multiple": "",
      "limit": 2,
      "on-exceed": _vm.handleExceed,
      "headers": _vm.postHead
    }
  }, [(_vm.upState == 'wait') ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("上传")]) : _vm._e(), _vm._v(" "), (_vm.upState == 'loaded') ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("更新")]) : _vm._e()], 1), _vm._v(" "), _c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loading'),
      expression: "upState == 'loading'"
    }],
    attrs: {
      "type": "circle",
      "percentage": _vm.percentage,
      "width": 45,
      "stroke-width": 3
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loaded'),
      expression: "upState == 'loaded'"
    }],
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": _vm.filesDown
    }
  }, [_vm._v("\n      下载\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-651a4bcd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/uploadPdf.vue
// module id = 1755
// module chunks = 1